import { render, staticRenderFns } from "./SectionNeeds.vue?vue&type=template&id=c3de0110&scoped=true&"
var script = {}
import style0 from "./SectionNeeds.vue?vue&type=style&index=0&id=c3de0110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3de0110",
  null
  
)

export default component.exports